// src/data/productData.js - Main export file for all product data

// Import all product data from individual files
import { screensData } from './screensData';
import { transducersData } from './transducersData';
import { batteriesData } from './batteriesData';
import { shuttlesData } from './shuttlesData';
import { polesData } from './polesData';

// Export all product data
export {
  screensData,
  transducersData,
  batteriesData,
  shuttlesData,
  polesData
};

// Helper functions for finding products
export const findProductById = (productType, id) => {
  let dataArray;
  
  switch(productType) {
    case 'screen':
      dataArray = screensData;
      break;
    case 'transducer':
    case 'livescope':
    case 'openWater':
    case 'iceFisher':
      dataArray = transducersData;
      break;
    case 'battery':
      dataArray = batteriesData;
      break;
    case 'shuttle':
      dataArray = shuttlesData;
      break;
    case 'pole':
      dataArray = polesData;
      break;
    default:
      return null;
  }
  
  return dataArray.find(item => item.id === id);
};

export const findProductByName = (productType, name) => {
  let dataArray;
  
  switch(productType) {
    case 'screen':
      dataArray = screensData;
      break;
    case 'transducer':
    case 'livescope':
    case 'openWater':
    case 'iceFisher':
      dataArray = transducersData;
      break;
    case 'battery':
      dataArray = batteriesData;
      break;
    case 'shuttle':
      dataArray = shuttlesData;
      break;
    case 'pole':
      dataArray = polesData;
      break;
    default:
      return null;
  }
  
  return dataArray.find(item => item.name === name);
}; 